import axios from "lib/axios";

const getMyProfile = async () => {
  const { data } = await axios.get("/me");
  return data;
};

export { getMyProfile };
